import React, { useEffect } from 'react';
import { useAuth } from '../../Services/AuthContext';
import { RoleNames } from '../../utils/Constants';
import { FormLabel } from './FormLabel';
import { FormGroup } from 'reactstrap';
import { useFormikContext } from 'formik';
import ErrorMessage from './ErrorMessage';
import AdminClientSelector from './AdminClientSelector';

const ClientSelector = ({ value,id,noEdit,route,all }) => {
    const [user] = useAuth();
    const { setFieldValue,...rest } = useFormikContext();
    useEffect(() => {
        
        if (user.role === RoleNames.ClientStaff) {
            if (value !== user.clientStaffId) {
                setFieldValue(id, user.clientStaffId);
            }
        } else if (user.role === RoleNames.ClientDepartment) {
            if (value !== user.clientDepartmentId) {
                setFieldValue(id, user.clientDepartmentId);
            }
        } else if (user.role === RoleNames.Client) {
            if (value !== user.clientId) {
                setFieldValue(id, user.clientId);
            }
        }
    }, [user,id,value,setFieldValue]);
    if (!noEdit && user.role === RoleNames.Admin) {
        return <FormGroup><FormLabel>Client</FormLabel><AdminClientSelector all={all} route={route} id={id} {...rest} />
                <ErrorMessage name={ id} />
            </FormGroup>
    }
    else {
        return <ErrorMessage name={id} />;
    }
}
export default ClientSelector; 